export default __webpack_public_path__ + "82edde5d95d331e52685456fcbcdb599.svg";